<template>
    <div class="login_info_end no-trans" v-loading="loading">
        <div class="login_info_end_box" v-if="type==1">
            <div class="titles">
                提交成功
            </div>
            <div class="bordes"></div>
            <div class="img_box">
                <div class="imgs">
                    <img src="../../assets/img/login/success.png" alt=""> 
                </div>
            </div>
            <div class="titles2">提交成功</div>
            <div class="texts">您耐心等候，审核通过后，在个人中心-消息中查看</div>
            <div class="btns_flex">
                <div class="btns1" @click="$router.push('/user_grzx')">
                    查看消息
                </div>
                <div class="btns2" @click="$router.push('/')">
                    返回首页
                </div>
            </div>
        </div>



        <div class="login_info_end_box" v-if="type==2">
            <div class="titles">
                审核状态
            </div>
            <div class="bordes"></div>
            <div class="img_box">
                <div class="imgs">
                    <img src="../../assets/img/login/success.png" alt=""> 
                </div>
            </div>
            <div class="titles2">审批通过</div>
            <div class="texts">恭喜你，你成功申请成为**会员</div>
            <div class="btns_flex">
                <div class="btns1" @click="$router.push('/')">
                    继续浏览
                </div>
            </div>
        </div>
       

        <div class="login_info_end_box" v-if="type==3">
            <div class="titles">
                审核状态
            </div>
            <div class="bordes"></div>
            <div class="img_box">
                <div class="imgs">
                    <img src="../../assets/img/login/shibai.png" alt=""> 
                </div>
            </div>
            <div class="titles2">审批未通过</div>
            <div class="texts">对不起，审核不通过，你只能成为**会员</div>
            <div class="text2">
                原因：这里是审核不通过的原因文字介绍这里是审核不通过的原因文字介绍这里是审核不通过的原因文字介绍这里是审核不通过的原因文字介绍
            </div>
            <div class="btns_flex">
                <div class="btns1">
                    完善资料
                </div>
                <div class="btns2" @click="$router.push('/')">
                    继续浏览
                </div>
            </div>
        </div>
        <div class="login_info_end_box" v-if="type==4">
            <div class="titles">
                审核状态
            </div>
            <div class="bordes"></div>
            <div class="img_box">
                <div class="imgs">
                    <img src="../../assets/img/login/shenhezhong.png" alt=""> 
                </div>
            </div>
            <div class="titles2">审核中</div>
            <div class="texts">您耐心等候，审核中</div>
           
            <div class="btns_flex">
                <div class="btns1" @click="$router.push('/')">
                    继续浏览
                </div>
               
            </div>
        </div>



        
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
 


export default {
    components: {
       
    },
    name: "homes",
    data() {
        return {
            loading:false,
            type:4,//1提交成功 2审批通过 3审批未通过 4审核中     
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() { 
        this.type=this.$route.query.type

    },
    methods: {
        



    },

}
</script>
<style scoped lang="less">
.login_info_end{
    width: 100%;
    // height: 680px;
    background-color: #FFFFFF;
    padding:21px ;
    padding-bottom: 100px;
    .login_info_end_box{
        width: 1440px;
        margin: auto;
        .titles{
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 24px;
            color: #333333;

        }
        .bordes{
            width: 1400px;
            height: 1px;
            background: #D5D8DE;
            border-radius: 0px 0px 0px 0px;
            margin-top: 16px;
        }
        .img_box{
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 64px;
            img{
                width:80px;
                height: 80px;
            }
        }
        .titles2{
            text-align: center;
            padding-top: 24px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 24px;
            color: #000000;

        }
        .texts{
            font-family: SourceHanSansCN-Regular, SourceHanSansCN-Regular;
            font-weight: normal;
            font-size: 14px;
            color: #999999;
            text-align: center;
            padding-top: 17px
        }
        .text2{
            text-align: center;   
            font-family: SourceHanSansCN-Regular, SourceHanSansCN-Regular;
            font-weight: normal;
            font-size: 14px;
            color: #999999;
            padding-top: 24px;
            width: 500px;
            margin: auto;
        }
        .btns_flex{
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 33px;
            .btns1{
                width: 128px;
                height: 40px;
                background: #377CFD;
                text-align: center;
                line-height: 40px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                cursor: pointer;
                border-radius: 8px;
            }
            .btns2{
                width: 128px;
                height: 40px;
                background: #FFFFFF;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #377CFD;
                text-align: center;
                line-height: 40px;
                cursor: pointer;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #377CFD;
                margin-left: 24px;
                border-radius: 8px;

            }
        }
    }
}

</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .login_info_end.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding: 16px;
        padding-bottom: 16px;
    }
    .login_info_end.no-trans .login_info_end_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .login_info_end.no-trans .login_info_end_box .titles {
        font-size: 24px;
    }
    .login_info_end.no-trans .login_info_end_box .bordes {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 1px;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
    }
    .login_info_end.no-trans .login_info_end_box .img_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .login_info_end.no-trans .login_info_end_box .img_box img {
        width: 80px;
        height: 80px;
    }
    .login_info_end.no-trans .login_info_end_box .titles2 {
        padding-top: 16px;
        font-size: 24px;
    }
    .login_info_end.no-trans .login_info_end_box .texts {
        font-size: 14px;
        padding-top: 16px;
    }
    .login_info_end.no-trans .login_info_end_box .text2 {
        font-size: 14px;
        padding-top: 16px;
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .login_info_end.no-trans .login_info_end_box .btns_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .login_info_end.no-trans .login_info_end_box .btns_flex .btns1 {
        width: 128px;
        height: auto;
        line-height: 1.6;
        font-size: 14px;
        border-radius: 8px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .login_info_end.no-trans .login_info_end_box .btns_flex .btns2 {
        width: 128px;
        height: auto;
        border-radius: 8px;
        line-height: 1.6;
        font-size: 14px;
        margin-left: 16px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
